'use client';
import React from 'react';

interface LiveStatsProps {
  wpm: number;
  accuracy: number;
  timeLeft: number;
  keystrokes: number;
  testState: 'idle' | 'active' | 'completed';
}

function fmt(t: number): string {
  const m = Math.floor(t / 60);
  const s = t % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

/**
 * Compact live-metric strip shown on the stage head (time / wpm / accuracy).
 * The progress bar lives on the stage itself, not here.
 */
export default function LiveStats({ wpm, accuracy, timeLeft, testState }: LiveStatsProps) {
  const isLowTime = timeLeft <= 10 && testState === 'active';

  return (
    <div className="type-metrics">
      <div className={`type-metric ${isLowTime ? 'type-metric-danger' : 'type-metric-accent'}`}>
        <span
          className="type-metric-value big"
          style={isLowTime ? { color: 'var(--incorrect)' } : undefined}
        >
          {fmt(timeLeft)}
        </span>
        <span className="type-metric-label">Time</span>
      </div>

      <div className="type-metric">
        <span className="type-metric-value">{wpm}</span>
        <span className="type-metric-label">WPM</span>
      </div>

      <div className="type-metric">
        <span className="type-metric-value">{accuracy.toFixed(0)}%</span>
        <span className="type-metric-label">Acc</span>
      </div>
    </div>
  );
}
